import React from 'react'
import ReactDOM from 'react-dom'
import 'react-dates/initialize'
import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'
import { store } from './store'
import Routes from './Routes'
import { unregister } from './registerServiceWorker'
import theme from './styled/theme'
import config from './config'
import './styled/globals'
import Toast from './components/toast'

if (config.clarityProjectId) {
	;(function(c, l, a, r, i, t, y) {
		c[a] =
			c[a] ||
			function() {
				;(c[a].q = c[a].q || []).push(arguments)
			}
		t = l.createElement(r)
		t.async = 1
		t.src = 'https://www.clarity.ms/tag/' + i
		y = l.getElementsByTagName(r)[0]
		y.parentNode.insertBefore(t, y)
	})(window, document, 'clarity', 'script', config.clarityProjectId)
}

ReactDOM.render(
	<Provider store={store}>
		<ThemeProvider theme={theme}>
			<React.Fragment>
				<Toast />
				<Routes />
			</React.Fragment>
		</ThemeProvider>
	</Provider>,
	document.getElementById('root')
)

unregister()
